import {useState} from 'react';
import {useSelector} from 'react-redux';
import {Grid, Container, Header, Image, Message, List} from 'semantic-ui-react';

import httpClient from 'httpClient';
import {getAppCatalogueSiteManagementLink} from 'state/selectors';
import nexusIcon from 'static/nexus_icon.png';

import NexusCreationForm from './NexusCreationForm';

import styles from './NexusCreation.module.scss';

const NexusCreation = () => {
  const [showForm, setShowForm] = useState(true);
  const [creationError, setCreationError] = useState(null);
  const [projectName, setProjectName] = useState('');
  const ppCatalogueSiteMgmLink = useSelector(getAppCatalogueSiteManagementLink);

  const createNexusSite = async newProjectData => {
    setCreationError(null);
    try {
      await httpClient.post('/api/nexus/sites', newProjectData, {
        handleErrorsCentrally: false,
      });
      setProjectName(newProjectData.name);
      setShowForm(false);
    } catch (err) {
      let creationErrorMessage = '';
      if (err.response.data.errors) {
        creationErrorMessage += JSON.stringify(err.response.data.errors.json);
      }
      if (err.response.data.error) {
        creationErrorMessage += err.response.data.error;
      }
      setCreationError(creationErrorMessage);
    }
  };

  return (
    <Grid centered>
      <Grid.Column className={styles.NexusCreation}>
        <Container>
          <Header as="h3" className={styles.Header}>
            <Image src={nexusIcon} alt="nexus icon" className={styles.HeaderIcon} />
            Creating a project for a Nexus site
          </Header>
          {showForm ? (
            <div>
              <p>
                You're minutes away from getting your App Catalogue project for hosting your Nexus
                instance.
              </p>
            </div>
          ) : (
            <div>
              <p>The project {projectName} has been created. </p>
              <p>
                You can manage it through the{' '}
                <a
                  href={new URL(`${ppCatalogueSiteMgmLink}/${projectName}`).toString()}
                  target="_blank"
                  rel="noreferrer"
                >
                  OKD console
                </a>
                .
              </p>
              Please follow the configuration instructions to finalize the setup of your
              application:
              <List bulleted>
                <List.Item>
                  <a
                    href="https://gitlab.cern.ch/vcs/nexus-cern-operator/-/blob/master/README.md"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Nexus
                  </a>
                </List.Item>
              </List>
            </div>
          )}
        </Container>
        {creationError && (
          <Message negative>
            <Message.Header>There was a problem creating the project</Message.Header>
            <p>{creationError}</p>
            <p>
              Please try again or open a{' '}
              <a
                href="https://cern.service-now.com/service-portal?id=service_element&name=web-portal"
                target="_blank"
                rel="noreferrer"
              >
                ticket
              </a>
            </p>
          </Message>
        )}
        {showForm && <NexusCreationForm create={createNexusSite} />}
      </Grid.Column>
    </Grid>
  );
};

export default NexusCreation;
